<template>
  <app-base-main style="padding-top: 6px">
    <template #base-content>
    <gj-app-top-tabs v-if="tabs.length > 0" v-model="tabActive" :tabs="tabs">
      <keep-alive>
        <component :is="tabActive === 'SHOP' ? 'SHOP' : 'msku'" :asinType="tabActive"></component>
      </keep-alive>
    </gj-app-top-tabs>
    </template>
  </app-base-main>
</template>

<script>
  import msku from "@/views/modules/statistics/common/analysis/goods-analysis/listing-analysis-goods";
  import SHOP from "@/views/modules/statistics/common/analysis/market/market-analysis-performance";
  import GjAppTopTabs from '@/views/modules/statistics/profit-statistics-copy/components/app-top-tabs.vue'

  export default {
    name: "listing-analysis-new",
    components: {
      msku,
      SHOP,
      GjAppTopTabs
    },
    data() {
      return {
        tabActive: '',
        tabGoods: [
          {id: 'msku', text: 'MSKU'},
          {id: 'asin', text: 'ASIN',},
          {id: 'variationAsin', text: '父ASIN'},
        ],
        tabShop: [
          {id: 'SHOP', text: '店铺'},
        ]
      }
    },
    computed:{
      tabs(){
        let tabs = [];
        if(this.$permission('listingAnalyze:view')){
          tabs = [...this.tabGoods];
        }
        if(this.$permission('storeAnalyze:view')){
          tabs.push.apply(tabs, this.tabShop);
        }
        this.initActive(tabs);
        return tabs;
      },
    },
    methods: {
      initActive(tabs){
        if (tabs.length > 0) {
           this.tabActive  = tabs[0].id
        }
      }
    }
  }
</script>

<style scoped lang="scss">

 /deep/ .tabs-header{
    margin-bottom: 12px;
    height: 31px;
  }
  /deep/ .profit-statistics-widget-msku{
    padding: 0;
  }
  /deep/ .base-content{
    height: 100%;
    .gj-top-tabs-box{
      display: flex;
      flex-direction: column;
    }
    .tabs-content{
      flex: 1;
      overflow: auto;
    }
  }

</style>
